<template>
    <q-page padding class="docs-input row justify-center">

        <alert display-page="login" class="col-12"/>

        <div class="col-12" style="width: 500px; max-width: 90vw;">
            <q-card class="shadow-20 q-pa-md bg-opacity-9">
                <div class="flex flex-center q-pt-md">
                    <a :href="base_url">
                        <img src="~assets/rebit.svg" style="width: 130px">
                    </a>
                </div>
                <q-item>
                    <q-item-section>
                        <q-item-label style="font-size: 18px; text-align: center">{{$t('create_new_rebit_account')}}</q-item-label>
                    </q-item-section>
                </q-item>

                <q-card-section>
                    <form>
                        <div class="row q-col-gutter-md">
                            <div class="col-12">
                                <q-input
                                    autofocus
                                    outlined
                                    v-model="user.email"
                                    :label="$t('email')"
                                    :error="user.errors.has('email')"
                                    :error-message="user.errors.get('email')"
                                    :rules="[val => (!!val && $options.filters.validateEmail(val)) || $t('please_enter_your_email')]"
                                    lazy-rules
                                    color="primary"
                                    input-class="text-center ltr"
                                    ref="email"
                                    class="input-ltr"
                                >
                                    <template v-slot:prepend>
                                        <q-icon name="fa fa-envelope" color="primary"/>
                                    </template>
                                    <template v-slot:append>
                                        <q-icon name="fa fa-dot" color="white"/>
                                    </template>
                                </q-input>
                            </div> <!-- Email -->
                            <div class="col-12">
                                <q-input
                                    v-model="user.password"
                                    :type="isPwd ? 'password' : 'text'"
                                    :label="$t('password')"
                                    lazy-rules
                                    :error="user.errors.has('password')"
                                    :error-message="user.errors.get('password')"
                                    color="primary"
                                    input-class="text-center ltr"
                                    class="input-ltr"
                                    ref="password"
                                    @keypress.enter="submit"
                                    outlined
                                >
                                    <template v-slot:prepend>
                                        <q-icon
                                            name="fa fa-lock"
                                            color="primary"
                                        />
                                    </template>
                                    <template v-slot:append>
                                        <q-icon
                                            :name="isPwd ? 'fa fa-eye-slash' : 'fa fa-eye'"
                                            class="cursor-pointer"
                                            @click="isPwd = !isPwd"
                                            color="grey-5"
                                        />
                                    </template>
                                </q-input>
                                <div class="text-caption" v-html="$t('password_criteria')"></div>
                            </div> <!-- Password -->
                            <div class="col-12">
                                <q-select
                                    outlined
                                    v-model="user.country_id"
                                    :label="$t('country_of_residence')"
                                    ref="country"
                                    emit-value
                                    map-options
                                    option-value="id"
                                    option-label="name"
                                    use-input
                                    :options="options"
                                    :loading="loading"
                                    :error="user.errors.has('country_id')"
                                    :error-message="user.errors.get('country_id')"
                                    :rules="[ val => val || $t('country_is_required')]"
                                    color="primary"
                                    @filter="filterCountries"
                                >
                                    <template v-slot:option="scope">
                                        <q-item
                                            v-bind="scope.itemProps"
                                            v-on="scope.itemEvents"
                                        >
                                            <q-item-section avatar>
                                                <q-icon :name="scope.opt.code" size="sm" />
                                            </q-item-section>
                                            <q-item-section>
                                                <q-item-label>{{scope.opt.name}}</q-item-label>
                                            </q-item-section>
                                        </q-item>
                                    </template>
                                    <template v-slot:prepend>
                                        <q-icon
                                            name="fa fa-globe"
                                            color="primary"
                                        />
                                    </template>
                                </q-select>
                            </div> <!-- Country -->
                            <div class="col-12">
                                <q-input
                                    v-model="user.referral_code"
                                    :label="$t('auth.referral_code')"
                                    :error="user.errors.has('referral_code')"
                                    :error-message="user.errors.get('referral_code')"
                                    :hint="$t('auth.referral_code_hint')"
                                    align="center"
                                    color="primary"
                                    input-class="text-center"
                                    class="letter-space-sm"
                                    maxlength="6"
                                    outlined
                                >
                                    <template v-slot:prepend>
                                        <q-icon name="fa fa-gift" color="primary"/>
                                    </template>
                                </q-input>
                            </div> <!-- REWARD CODE -->
                        </div>
                    </form>
                </q-card-section>

                <q-card-section>
                    <i18n path="terms" tag="div" class="text-weight-light">
                        <template #terms_and_conditions>
                            <a :href="base_url+'/terms-of-use'" target="_blank">{{$t('terms_and_conditions')}}</a>
                        </template>
                        <template #policy>
                            <a :href="base_url+'/privacy-policy'">{{$t('privacy_policy')}}</a>
                        </template>
                    </i18n>
                </q-card-section>

                <q-card-actions class="row q-col-gutter-md">
                    <div class="col-12">
                        <q-btn class="bg-gradient-btn full-width" text-color="white"
                               @click="submit">{{ $t('auth.sign_up') }}
                        </q-btn>
                    </div>
                    <div class="col-12">
                        <q-btn class="full-width" color="primary" flat @click="$router.push({name: 'login'})" :label="$t('i_already_have_an_account')" />
                    </div>
                </q-card-actions>
            </q-card>
        </div>
        <q-dialog v-model="displayRegisterConfirmation">
            <q-card style="width: 500px; max-width: 450vw;" class="q-pa-sm">
                <q-card-section>
                    <div class="text-h6">{{$t('auth.errors.email_already_taken')}}</div>
                </q-card-section>

                <q-card-section class="q-pt-none">
                    <p>{{$t('auth.errors.you_or_someone_else_has_created_an_unverified_account_with_this_email_already')}}</p>
                </q-card-section>

                <q-card-actions class="row q-col-gutter-md">
                    <div class="col-12">
                        <q-btn v-close-popup flat align="right" class="full-width" color="primary" :label="$t('auth.i_forgot_my_password')" @click="$router.push({name: 'forgot'})" />
                    </div>
                    <div class="col-12">
                        <q-btn v-close-popup flat align="right" class="full-width" color="primary" :label="$t('auth.i_know_the_password_go_to_login')" @click="$router.push({name: 'login'})" />
                    </div>
                    <div class="col-12">
                        <q-btn v-close-popup flat align="right" class="full-width" color="primary" :label="$t('auth.not_sure_create_a_new_account')" @click="forceSubmit()"/>
                    </div>
                </q-card-actions>
            </q-card>
        </q-dialog>
    </q-page>
</template>

<script>
import {RegisterMixin} from './RegisterMixin'
import {RecaptchaMixin} from './RecaptchaMixin'
import {mapActions, mapGetters} from 'vuex'
import Alert from 'Modules/Alert/resources/components/Alert'
import countries from 'src/assets/countries.json'
export default {
    name: 'Register',
    mixins: [RegisterMixin, RecaptchaMixin],
    computed: {
        ...mapGetters(['id_valid_countries']),
        mobile() {
            return this.user.mobile.replace(/\s/g, "")
        }
    },
    data() {
        return {
            isPwd: true,
            loading: false,
            options: null,
            base_url: process.env.BASE_URL,
            displayRegisterConfirmation: false,
            all_countries: {countries: countries.filter(country => country.is_main)},
            ip_geolocation_token: process.env.IPGEOLOCATION_TOKEN
        }
    },
    methods: {
        ...mapActions(['register', 'forgot', 'confirm_email', 'user_info', 'set_countries']),
        isCredentialsFilled() {
            if(!this.user.email) {
                this.$refs.email.focus()
                return false;
            }

            if(!this.user.password) {
                this.$refs.password.focus()
                return false;
            }

            if(!this.user.country_id) {
                this.$refs.country.focus()
                return false;
            }

            return true;
        },
        resetValidations() {
            this.$refs.email.resetValidation()
            this.$refs.password.resetValidation()
            this.$refs.country.resetValidation()
        },
        submit() {
            if(!this.isCredentialsFilled()) {
                return
            }

            this.$q.loading.show()
            if (process.env.ENV !== 'local') {
                this.recaptcha().then((token) => {
                    this.user.recaptcha = token
                    this.doRegister()
                }).catch(error => {
                    this.$q.notify({
                        message: this.$t('auth.errors.poor_connection_refresh_and_try_again'),
                        timeout: 3000,
                        color: 'negative',
                        position: 'center',
                        icon: 'fa fa-exclamation-triangle'
                    })
                })
            } else {
                this.doRegister()
            }
        },
        doRegister() {
            this.register(this.user).then(() => {
                this.resetValidations()
                this.$q.loading.hide()
                this.$q.notify({
                    message: this.$t('auth.you_are_successfully_registered'),
                    color: 'positive',
                    position: 'top',
                    icon: 'fa fa-check'
                })
                this.user_info().then(() => {
                    this.$router.push({name: 'dashboard'})
                })
            }).catch((response) => {
                this.recaptcha().then((token) => this.user.recaptcha = token)
                this.$q.loading.hide()
                if (response.status === 500) {
                    this.$q.notify({
                        message: this.$t('auth.error_in_registration_operation'),
                        color: 'negative',
                        position: 'center',
                        icon: 'fa fa-exclamation-triangle'
                    })
                } else if (response.status === 412) {
                    this.$q.notify({
                        message: response.data.error,
                        color: 'negative',
                        position: 'center',
                        icon: 'fa fa-exclamation-triangle'
                    })
                } else if (response.status === 422) {
                    if (this.user.errors.has('email') && this.user.errors.get('email') === 'This email is already taken!') {
                        this.displayRegisterConfirmation = true
                    } else if(this.user.errors.has('recaptcha')) {
                        this.recaptcha().then((token) => this.user.recaptcha = token)
                        this.$q.notify({
                            message: $t('auth.errors.invalid_recaptcha'),
                            caption: $t('auth.errors.it_may_be_due_to_your_internet_speed'),
                            color: 'negative',
                            position: 'center',
                            timeout: 6000,
                            icon: 'fa fa-exclamation-triangle'
                        })
                    }
                } else {
                    this.$q.notify({
                        message: this.$t('unspecified_error'),
                        color: 'negative',
                        position: 'center',
                        icon: 'fa fa-exclamation-triangle'
                    })
                }
            })
        },
        forceSubmit() {
            this.user.force = true
            this.submit()
        },
        confirm() {
            this.$q.loading.show();
            this.confirm_email(this.user).then(({}) => {
                this.$q.loading.hide()
                this.$q.notify({
                    message: this.$t('auth.successful_register_message'),
                    position: 'center'
                })
                this.$router.push({name: 'login'})
            }).catch((error) => {
                this.$q.loading.hide();
                this.$q.notify({
                    message: this.$t('auth.activation_code_not_approved'),
                    color: 'negative',
                    position: 'center',
                    icon: 'fa fa-exclamation-triangle'
                })
            })
        },
        resend() {
            this.$q.loading.show();
            this.forgot({email: this.user.email}).then(() => {
                this.$q.loading.hide();
                this.$q.notify({
                    message: $t('auth.errors.check_your_email_and_use_the_verification_code'),
                    position: 'center'
                })
            }).catch(({data}) => {
                this.$q.notify({
                    message: data.error,
                    timeout: 1000,
                    color: 'negative',
                    position: 'center',
                    icon: 'fa fa-exclamation-triangle'
                })
                this.$q.loading.hide();
            })
        },
        filterCountries(val, update, abort) {
            if (val === '') {
                update(() => {
                    this.options = this.all_countries.countries
                })
                return
            }

            update(() => {
                const needle = val.toLowerCase()
                this.options = this.all_countries.countries.filter(country => country.name.toLowerCase().indexOf(needle) > -1)
            })
        },
        async setCountry() {
            try {
                this.user.country_id = await this.$geoLocation(this.options)
            } catch (error) {
                console.error('Failed to fetch geolocation:', error)
            }
        }
    },
    created() {
        this.user.referral_code = this.$route.query.code
    },
    mounted() {
        this.options = this.all_countries.countries
        this.user.country_id = this.$q.cookies.get('ip_country')
        this.setCountry()
    },
    components: {Alert}
}
</script>
<style>
.letter-space-sm input[type=text] {
    letter-spacing: 10px;
    text-align: center;
    text-transform: uppercase;
}
</style>
